import React from "react";
import { Business, Dinner, Gift, Gym, Microphone, Parking, Pool, Spa, Other, Kids } from "./icons";

export function getAmenityName (num) {
  switch (Number(num)) {
    case 0:
      return { icon: <Pool />, name: 'Pool', type: 'pool' };
    case 1:
      return { icon: <Gym />, name: 'Fitness & Activities', type: 'gym' };
    case 2:
      return { icon: <Spa />, name: 'Spa', type: 'spa' };
    case 3:
      return { icon: <Business />, name: 'Business Services', type: 'business' };
    case 4:
      return { icon: <Other />, name: 'Other', type: 'other' };
    case 5:
      return { icon: <Dinner />, name: 'Dining', type: 'dining' };
    case 6:
      return { icon: <Microphone />, name: 'Events', type: 'events' };
    case 7:
      return { icon: <Kids />, name: 'Kids allowed', type: 'kids' };
    case 98:
      return { icon: <Parking />, name: 'Parking', type: 'parking' };
    case 99:
      return { icon: <Gift />, name: 'Offers' };

    default:
      return { icon: <Other />, name: 'Other', type: 'other' };
  }
}
